module.exports = __webpack_public_path__ + "img/movil3.857bb992.jpg";